import wellboreService from 'services/wellbore.service';

import { WELL_EVENTS_PAGE_LOADED } from 'features/wells/events/wellEvents.constants';

export const onLoad = (fieldId, wellId) => (dispatch) =>
  dispatch({
    type: WELL_EVENTS_PAGE_LOADED,
    payload: () => wellboreService.getWellboreEvents(fieldId, wellId),
  });
